<template>
  <div id="app" style="font-size: 12px;">
    <div class="header">
      <!-- <span>合约列表</span> -->
      <div class="right">
        收费合计：<span class="red">{{ he }} 元</span>
        订单合计：<span class="green">{{ ddhj }} 单</span>
        <a v-if="false" :href="export_url" target="_blank" class="btn btn-success btn-xs"
           style="float: right;padding: 5px 14px;height: 30px;margin:0 20px 5px 20px">导出excel</a>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div class="line"></div>

    <div style="position: relative;margin-bottom: 40px;">
      <div class="top">
        <label>商品名称：</label>
        <select name="" id="" v-model="s_id">
          <option value="">请选择</option>
          <option v-for="item in goods_list" :value="item.s_id">{{ item.s_name }}</option>
        </select>
        <label>顾问：</label>
        <select name="" id="" v-model="u_id">
          <option value="">请选择</option>
          <option v-for="item in name_list" :value="item.user_id">{{ item.username }}</option>
        </select>
        <label>签约日期：</label>
        <el-date-picker
          v-model="value1"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="开始日期">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="value2"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="结束日期">
        </el-date-picker>

        <!--<el-select v-model="item_id" placeholder="请选择合约" size="mini" style="width: 130px;height: 30px;line-height: 30px;margin-left: 10px;vertical-align: middle">-->
        <!--<el-option value="">请选择</el-option>-->
        <!--<el-option v-for="item in items" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
        <!--</el-select>-->
        <label>合同编号</label>
        <!--@keyup.enter="search"-->
        <input type="text" v-model="hetong" class="inp">
        <label>会员姓名</label>
        <!--@keyup.enter="search"-->
        <input type="text" v-model="bao_name" class="inp">
        <el-button @click="search" type="success" size="mini" icon="el-icon-search"></el-button>
      </div>
    </div>

    <table style="width: 100%;margin-top:60px;">
      <thead>
      <tr style="height:40px;background-color: #f3f4f8;border-bottom: 1px solid gainsboro;">
        <th>#</th>
        <th>会员姓名</th>
        <th>合同编号</th>
        <!--                <th>合约类型</th>-->
        <th>商品名称</th>
        <th>总次数</th>
        <th>剩余次数</th>
        <th>应收金额</th>
        <th>实收金额</th>
        <th>单价</th>
        <th>签约日期</th>
        <th>到期日期</th>
        <th>销售人</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in tableData" style="height: 40px;border-bottom: 1px solid gainsboro;">
        <td>{{ index + 1 }}</td>
        <td>
          <a v-for="(data,index) in item.baobao_name" @click="jump(data.bao_id,data.vip)"
             style="margin-right: 8px">
            {{ data.baobao_name }}
          </a>
        </td>
        <td>{{ item.hetong }}</td>
        <!--                <td>{{item.item_name}}</td>-->
        <td>{{ item.s_name }}</td>
        <td>{{ item.s_keshi }}</td>
        <td>{{ item.y_keshi }}</td>
        <td>{{ item.receivable }}</td>
        <td>{{ item.shishou }}</td>
        <td>{{ item.avg_price }}</td>
        <td>{{ item.create_time }}</td>
        <td>{{ item.e_time }}</td>
        <td>{{ item.username }}</td>
      </tr>
      <tr v-if="tableData == ''" style="height: 40px;border-bottom: 1px solid gainsboro;">
        <td colspan="10">暂无数据</td>
      </tr>
      </tbody>
    </table>

    <div class="footer">
      共有<span>{{ table_list.count }}</span>条记录
      当前<span>{{ now_page }}</span>页/共<span>{{ table_list.total }}</span>页
      <!-- <div class="right">
          <button @click="page">首页</button>
          <button @click="page">上一页</button>
          <button @click="page">下一页</button>
          <button @click="page">尾页</button>
          <select name="" id="">
              <option value="">{{table_list.total}}</option>
          </select>
          <button @click="page" style="background-color: #7c73c4;padding: 3px 8px;">跳转</button>
      </div> -->
      <el-pagination
        @current-change="handleCurrentChange"
        background
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="currentPage3"
        :page-size="20"
        layout="prev, pager, next, jumper"
        :total="table_list.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: '',//开始日期
      value2: '',//结束日期
      hetong: '',//合同编号
      bao_name: '',//会员姓名
      u_id: '',
      tableData: [],
      table_list: [],
      name_list: [],//营销姓名
      goods_list: '',
      token: '',
      a: '',
      currentPage3: 1,
      now_page: 1,
      he: 0,
      ddhj: 0,
      all_keshi: '',
      sheng_keshi: '',
      items: [],//项目
      item_id: '',
      s_id: '',
      centre_id: 0,
      export_url: "javascript:void(0);",
    }
  },
  created() {
    let that = this
    that.token = that.$cookies.get('token');
    that.export_url = process.env.apiUrl + "saas/export/export_infos?token=" + that.token
    this.get_name()
    this.get_goods()
    this.get_table()
    this.get_item()
  },
  watch: {
    value1() {
      this.check_export_url();
    },
    value2() {
      this.check_export_url();
    },
  },
  methods: {
    //重新生成导出链接参数
    check_export_url() {
      let that = this
      that.export_url = process.env.apiUrl + "saas/export/export_infos?token=" + that.token + '&s_time=' + that.value1 + '&e_time=' + that.value2
    },
    //选择项目
    get_item() {
      let self = this;
      $.ajax({
        type: 'POST',
        url: process.env.apiUrl + "saas/biao/item_type",
        data: {
          token: self.token,
        },
        success: function (res) {
          if (res.status == 1) {
            self.items = res.data
            self.centre_id = res.centre_id
          }
        },
        error: function (data) {
          self.$message.error(`请求失败`);
        }
      });
    },
    //  营销姓名
    get_name() {
      let that = this
      $.ajax({
        url: process.env.apiUrl + "saas/user/allstaff",
        type: "post",
        dataType: "json",
        data: {
          token: that.token,
          type: 1
        },
        success: function (res) {
          that.name_list = res.data
        }
      });
    },
    //获取商品信息列表
    get_goods() {
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/get_ksb",
        type: "post",
        data: {
          token: that.token
        },
        success: function (data, status) {
          if (data.status == 1) {
            that.goods_list = data.data;
          }
        },
        fail: function (err, status) {
          console.log(err);
        }
      });
    },
    // 表格数据
    get_table() {
      let that = this
      $.ajax({
        url: process.env.apiUrl + "saas/biao/indexh",
        type: "post",
        dataType: "json",
        data: {
          token: that.token,
          user_id: that.u_id,
          time_s: that.value1,
          time_e: that.value2,
          hetong: that.hetong,
          name: that.bao_name,
          item_id: that.item_id,
          s_id: that.s_id
        },
        success: function (data) {
          that.tableData = data.data
          that.table_list = data
          that.he = data.he;
          that.ddhj = data.count;
          that.all_keshi = data.all_keshi;
          that.sheng_keshi = data.sheng_keshi;
          // that.table_list=data.data
          for (var i = 0; i < that.tableData.length; i++) {
            for (var j = 0; j < that.tableData[i].baobao_name.length; j++) {
              that.a = that.tableData[i].baobao_name[j].baobao_name
            }
          }
        }
      });
    },
    //搜索
    search() {
      let that = this
      $.ajax({
        url: process.env.apiUrl + "saas/biao/indexh",
        type: "post",
        dataType: "json",
        data: {
          token: that.token,
          user_id: that.u_id,
          time_s: that.value1,
          time_e: that.value2,
          hetong: that.hetong,
          name: that.bao_name,
          item_id: that.item_id,
          s_id: that.s_id
        },
        success: function (data) {
          that.tableData = data.data
          that.table_list = data
          that.he = data.he
          that.ddhj = data.count
          that.all_keshi = data.all_keshi;
          that.sheng_keshi = data.sheng_keshi;
          for (var i = 0; i < that.tableData.length; i++) {
            for (var j = 0; j < that.tableData[i].baobao_name.length; j++) {
              that.a = that.tableData[i].baobao_name[j].baobao_name
            }
          }
        }
      });
    },
    //跳转会员页
    jump(b_id, v) {
      this.$router.push({
        path: '/huiyuanx',
        query: {id: b_id, vip: v}
      })
    },
    //分页
    handleCurrentChange(val) {
      let that = this
      that.now_page = val
      $.ajax({
        url: process.env.apiUrl + "saas/biao/indexh",
        type: "post",
        dataType: "json",
        data: {
          token: that.token,
          page: that.now_page,
          user_id: that.u_id,
          time_s: that.value1,
          time_e: that.value2,
          hetong: that.hetong,
          name: that.bao_name,
          s_id: that.s_id
        },
        success: function (data) {
          that.tableData = data.data
          that.table_list = data
          that.he = data.he;
          that.ddhj = data.count;
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
#app {
  padding: 10px;
}

.header {
  margin: 10px 15px 5px;
  //  font-size: 18px;
  .right {
    float: right;

    .red {
      color: red;
      margin-right: 15px;
    }

    .green {
      color: forestgreen;
    }
  }
}

.line {
  position: relative;
  margin-bottom: 20px;
}

.line::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 1px solid black;
  width: 200%;
  height: 200%;
  transform-origin: 0 0;
  transform: scale(0.5, 0.5);
  box-sizing: border-box;
}

.top {
  position: absolute;
  right: 0;

  label {
    margin-left: 3px;
  }

  select {
    height: 26px;
    border-radius: 2px;
  }

  .inp {
    width: 80px;
    height: 26px;
    border: 1px solid grey;
    border-radius: 2px;
    outline: none;
    padding-left: 10px;
  }
}

table {
  th, td {
    text-align: center;
  }
}

.footer {
  margin-top: 15px;

  .right {
    float: right;
  }

  select {
    height: 24px;
    padding-right: 5px;
    padding-left: 3px;
    border: 1px solid #7c73c4;
    border-radius: 1px;
    margin-left: 2px;
  }

  button {
    padding: 2px 8px;
    cursor: pointer;
    background-color: white;
    border: 1px solid #7c73c4;
    border-radius: 1px;
    margin-left: 2px;
  }
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 125px;
}

.el-input--suffix .el-input__inner {
  padding-right: 0;
}

.el-table {
  flex: none;
}

.el-pagination {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/heyue/heyue.vue